import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function OAuthTest() {
  const [searchParams] = useSearchParams();
  const [allParams, setAllParams] = useState<Record<string, string>>({});

  useEffect(() => {
    const params: Record<string, string> = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    setAllParams(params);
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">OAuth Test Page</h1>
          
          <div className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Current URL Parameters:</h2>
            {Object.keys(allParams).length > 0 ? (
              <div className="bg-gray-100 rounded-lg p-4">
                <pre className="text-sm text-gray-700">
                  {JSON.stringify(allParams, null, 2)}
                </pre>
              </div>
            ) : (
              <p className="text-gray-600">No URL parameters found</p>
            )}
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Full URL:</h2>
            <div className="bg-gray-100 rounded-lg p-4">
              <code className="text-sm text-gray-700 break-all">
                {window.location.href}
              </code>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Test OAuth Flow:</h2>
            <p className="text-gray-600 mb-4">
              Use this URL to test your Slack OAuth flow directly:
            </p>
            <div className="bg-blue-50 rounded-lg p-4 mb-4">
              <code className="text-sm text-blue-800 break-all">
                https://slack.com/oauth/v2/authorize?client_id=YOUR_CLIENT_ID&scope=app_mentions:read,chat:write,commands,im:history,im:read,users:read,team:read&redirect_uri=YOUR_SUPABASE_URL/functions/v1/slack-oauth
              </code>
            </div>
            <p className="text-sm text-gray-500">
              Replace YOUR_CLIENT_ID with your actual Slack app Client ID and YOUR_SUPABASE_URL with your Supabase project URL
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Expected OAuth Redirect URL:</h2>
            <div className="bg-green-50 rounded-lg p-4">
              <code className="text-sm text-green-800">
                YOUR_SUPABASE_URL/functions/v1/slack-oauth
              </code>
            </div>
            <p className="text-sm text-gray-500 mt-2">
              Replace YOUR_SUPABASE_URL with your actual Supabase project URL
            </p>
          </div>
        </div>
      </div>
    </div>
  );
} 